<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span>导入产品</span>
    </template>
    <template #content>
      <gj-upload
          :template-url="`/supply/transfer/downloadTemplate?arrivalWarehouseId=${arrivalWarehouseId}`"
          @uploadAfter="uploadAfter"
          container-type="TRANSFER"
          style="margin-bottom: 12px;">
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '支持导入格式为xls/xlsx的文件',
            '同一个SKU存在多条记录，以第一条记录为准',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "@/minxins";
  import {importTransferProduct} from "@/api/warehouse";

  export default {
    name: "app-import-product-modal",
    mixins: [modalMixIn, uploadMixin],
    props: {
      warehouseId: {
        required: true,
      },
      arrivalWarehouseId: {
        required: true,
      },
      arrivalMarketId: {
        required: true,
      },
    },
    data() {
      return {
      }
    },
    methods: {
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importTransferProduct({
          arrivalMarketId: this.arrivalMarketId,
          arrivalWarehouseId: this.arrivalWarehouseId,
          attachmentId: attId,
          warehouseId: this.warehouseId
        })
          .then((res) => {
            this.$gjImportHandle(res, uploadCb)
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
      }
    }
  }
</script>

<style scoped>

</style>
